<template>
  <v-dialog
    :value="dialog"
    max-width="500"
    @input="handleClose"
  >
    <v-card>
      <v-card-title>
        {{ isEditing ? 'メモを編集' : 'メモを追加' }}
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isValid"
        >
          <v-select
            v-model="formData.category"
            :items="categories"
            item-text="text"
            item-value="value"
            label="カテゴリ"
            dense
            outlined
            class="mb-3"
          />

          <v-textarea
            v-model="formData.content"
            :rules="[rules.required]"
            label="メモ内容"
            outlined
            rows="4"
            counter="500"
            maxlength="500"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="handleClose"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!isValid"
          :loading="isSaving"
          @click="handleSave"
        >
          {{ isEditing ? '更新' : '作成' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'

export default {
  name: 'CustomerNoteForm',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    editingNote: {
      type: Object,
      default: null,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const form = ref(null)
    const isValid = ref(false)
    const isSaving = ref(false)

    const formData = ref({
      content: '',
      category: 'preference',
    })

    const rules = {
      required: v => !!v || '必須項目です',
    }

    const isEditing = computed(() => !!props.editingNote?.id)

    // editingNoteが変更されたらフォームを更新
    watch(() => props.editingNote, note => {
      if (note) {
        formData.value = {
          content: note.content || '',
          category: note.category || 'preference',
        }
      } else {
        formData.value = {
          content: '',
          category: 'preference',
        }
      }
    }, { immediate: true })

    // ダイアログが開かれたらフォームをリセット
    watch(() => props.dialog, isOpen => {
      if (isOpen && !props.editingNote) {
        formData.value = {
          content: '',
          category: 'preference',
        }
      }
    })

    const handleClose = () => {
      emit('close')
    }

    const handleSave = () => {
      if (!isValid.value) return

      emit('save', {
        content: formData.value.content,
        category: formData.value.category,
      })
    }

    return {
      form,
      isValid,
      isSaving,
      formData,
      rules,
      isEditing,
      handleClose,
      handleSave,
    }
  },
}
</script>
